import { Deployment } from "@hostingbv/lib/src/api/partner/models/Deployment"
import { useEntityDeployments } from "@hostingbv/lib/src/api/partner/PartnerHooks"
import { SectionHeader } from "@hostingbv/lib/src/components/content/SectionHeader"
import { DeploymentStatusLabel } from "@hostingbv/lib/src/components/DeploymentStatusLabel"
import { useModal } from "@hostingbv/lib/src/components/layout/ModalProvider"
import { FC, useEffect } from "react"
import { DeploymentDetailsModal } from "../../modals/DeploymentDetailsModal"
import { Button } from "@hostingbv/lib/src/components/form/Button"
import { DataTable } from "@ventumsoftware/react-toolkit"

export const DeploymentHistoryBlock: FC<{ entityUUID: string }> = ({ entityUUID }) => {
  const { data, fetch } = useEntityDeployments(entityUUID)

  useEffect(() => {
    const interval = setInterval(() => fetch(), 2000)
    return () => clearInterval(interval)
  }, [fetch])

  return <div className="my-4">
    <SectionHeader>Deployment history</SectionHeader>
    <DataTable
      columns={[
        {
          header: 'Status', property: 'type', transform: (_, d) => <div>
            <DeploymentStatusLabel status={d.status} />
          </div>
        },
        { header: 'User', property: 'initiatedName' },
        { header: 'Date', property: 'started', transform: (d) => d === null ? <></> : <span>{d.toLocaleDateString('nl')} {d.toLocaleTimeString()}</span> },
        {
          header: 'Action', property: 'id', transform: (_, d) => <DeploymentDetailsButton deployment={d} />
        },
      ]}
      data={(data ?? []).slice(0, 10)}
      keyProperty={'id'}
    />
  </div>
}

const DeploymentDetailsButton = (props: { deployment: Deployment }) => {
  const { open } = useModal({ title: "Deployment details", size: 'lg', body: <DeploymentDetailsModal deployment={props.deployment} /> })
  return <div>
    <Button type={'secondary'} size={'xs'} text={'Details'} onClick={() => open()} />
  </div>
}
